import script from "./Datepicker.vue?vue&type=script&setup=true&lang=ts"
export * from "./Datepicker.vue?vue&type=script&setup=true&lang=ts"

import "./Datepicker.vue?vue&type=style&index=0&id=06c427c1&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-06c427c1"]])

export default __exports__